module.exports = __webpack_public_path__ + "img/COMBO SPIRAL GREEN.28bc259.svg";